import React from "react";
import "../App.css";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Divider } from "@material-ui/core";

export interface TitleData {
  title: string;
}

const useStyles = makeStyles({
  sectionTitle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  title: {
    flex: "2",
    textTransform: "uppercase",
    marginRight: "0.5em",
  },
  div: {
    flex: "5",
  }
});

export default function Title({ title }: TitleData) {
  const classes = useStyles();

  return (
    <div className={classes.sectionTitle}>
      <Typography variant="h5" component="h5" className={classes.title}>
        {title}
      </Typography>
      <Divider className={classes.div} />
    </div>
  );
}
